/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Threshold_TitleInputs */

const en_ui_labs_threshold_title = /** @type {(inputs: Ui_Labs_Threshold_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Your Threshold Pace`)
};

const de_ui_labs_threshold_title = /** @type {(inputs: Ui_Labs_Threshold_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setz dein Schwellentempo`)
};

/**
* | output |
* | --- |
* | "Set Your Threshold Pace" |
*
* @param {Ui_Labs_Threshold_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_threshold_title = /** @type {((inputs?: Ui_Labs_Threshold_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Threshold_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_threshold_title(inputs)
	return de_ui_labs_threshold_title(inputs)
});